import {Stack} from '@mui/material';
import styled from 'styled-components';

const StyledContainer = styled(Stack)`
	align-items: center;
	justify-content: center;
	gap: 16px;
	padding: 24px 16px;
`;

export {StyledContainer};
